"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _OptionPicker = require("../../common/OptionPicker");
var _mapUseOptionPicker2 = _interopRequireDefault(require("@deosite/helpers/mapUseOptionPicker"));
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function useOptionPicker(productForMap) {
  var isPro = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var _mapUseOptionPicker = (0, _mapUseOptionPicker2["default"])(productForMap),
    product = _mapUseOptionPicker.product,
    products = _mapUseOptionPicker.products,
    options = _mapUseOptionPicker.options;
  if (isPro) {
    products.forEach(function (productPro) {
      productPro.url = "".concat(productPro.url, "-").concat(productPro.sku);
    });
  }
  return (0, _OptionPicker.useOptionPicker)({
    products: products,
    options: options.map(function (o) {
      return _objectSpread(_objectSpread({}, o), {}, {
        missingProductStrategy: o.id === "color_trade_name" ? "alternative" : o.id === "size" ? "hidden" : "disabled"
      });
    }),
    initialProduct: product
  });
}
var _default = useOptionPicker;
exports["default"] = _default;